import React, { useState } from "react";

import {
  Create,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useNotify,
  useRedirect,
} from "react-admin";

import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { logError } from "../../../utils/appUtils";
import { CommodityForm } from "./CommodityForm";

const CreateActions = (props) => (
  <TopToolbar>
    <BackButton {...props} />
  </TopToolbar>
);

const CreateToolbar = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [saving, setSaving] = useState(false);

  const transform = async (data) => {
    setSaving(true);
    return { ...data };
  };

  const onSuccess = (data) => {
    setSaving(false);
    notify("Commodity created successfully", "success");
    redirect("list", "/commoditys");
  };

  const onFailure = (error) => {
    setSaving(false);
    logError("commoditys:CommodityCreate:onFailure", error, notify);
  };

  const savingProps = { ...props, saving: saving };
  return (
    <Toolbar {...savingProps}>
      <SaveButton
        label="Save"
        transform={transform}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
    </Toolbar>
  );
};

export const CommodityCreate = (props) => {
  return (
    <Create
      {...props}
      title={<ForceTitle title="Create Location" />}
      actions={<CreateActions {...props} />}
    >
      <SimpleForm submitOnEnter={false} toolbar={<CreateToolbar {...props} />}>
        <CommodityForm {...props} />
      </SimpleForm>
    </Create>
  );
};
